import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings.js";

import defaultCardImage from "../../images/shield-icon.svg";

import BackgroundImage from "images/custom/dot-background.jpeg";

import AlertIcon from "images/custom/alert.svg";
import LiveIcon from "images/custom/live.svg";
import ScheduleIcon from "images/custom/schedule.svg";
import ShareIcon from "images/custom/share.svg";
import TimelineIcon from "images/custom/timeline.svg";

const Container = styled.div`
  ${tw`relative -mx-8 px-0`}
  ${css`
    background-image: url(${BackgroundImage});
    background-repeat: repeat;
  `}
`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;
const Heading = tw(
  SectionHeading
)`w-full text-skywatch-primary800 px-4 font-bold`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;

const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-10 mt-12`}
  .imageContainer {
    ${tw`text-center p-0 flex-shrink-0 relative`}
    img {
      ${tw`w-20 h-20`}
    }
  }

  .textContainer {
    ${tw`mt-6 w-56 text-center`}
  }

  .title {
    ${tw`mt-2 font-bold text-2xl leading-none text-skywatch-primary800`}
  }

  .description {
    ${tw`mt-3 font-normal text-skywatch-textGray text-lg leading-normal`}
  }
`;

export default () => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component):
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const cards = [
    {
      imageSrc: LiveIcon,
      title: "即時影像",
      description: "打開 App，隨時觀看 Live 影像。"
    },
    {
      imageSrc: AlertIcon,
      title: "警報錄影",
      description: "動態影像偵測，可疑人士接近立即發送通知。"
    },
    {
      imageSrc: TimelineIcon,
      title: "事件紀錄",
      description: "依時間軸排序每日事件，一目了然所有重要時刻。"
    },
    {
      imageSrc: ScheduleIcon,
      title: "排程錄影",
      description: "自由設定雲端錄影起迄時間，兼顧安全與隱私。"
    },
    {
      imageSrc: ShareIcon,
      title: "權限分享",
      description: "設定帳號分享，共享管理你的重要影像。"
    }
  ];

  return (
    <Container>
      <ThreeColumnContainer>
        <Heading>5 大貼心服務，即時掌握場域動向</Heading>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title || "Fully Secure"}</span>
                <p className="description">
                  {card.description ||
                    "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud. Sic Semper Tyrannis. Neoas Calie artel."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
    </Container>
  );
};
